module.exports = __webpack_public_path__ + "img/ИФ-1(А)-012.6dd73eb0.png";